<template>
  <div class="container">
    <div class="top-btn-box">
      <img src="@/assets/images/app/logo.png"/>
      <div class="top-logo-box">
        <span>宠源源APP</span>
        <span style="color: #ACADAF;margin-top:2px;">爱宠物更爱自由</span>
      </div>
      <div class="top-open-btn" id="appBtn3">打开看看</div>
    </div>
    <div class="container-info">
      <div class="info-content">
        <div class="info-desc">宠源源聚焦宠物生态，深耕爱宠人群，汇聚宠物内容，为亿万宠物兴趣爱好者、养宠人士、宠物服务商家搭建一个桥梁，致力打造一个宠物兴趣综合平台、定义宠物行业职业新标准。</div>
        <img class="center-img" src="@/assets/images/share/center.png">
        <div class="down-btn" id="appBtn2">
          <div class="down-btn-box">
            <div class="open-box"><img src="@/assets/images/share/open_icon.png"/><span>宠 源 源</span>
            </div>
            <div style="height: 32px;line-height: 32px;">APP内打开</div>

          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>

export default {

  data() {
    return {
    };
  },

  mounted:function(){
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = '//cdn.xinstall.com/xinstall.js';
    s.addEventListener('load',()=>{
      var data = XInstall.parseUrlParams();

      new XInstall({
        /*xinstall中应用的唯一标识，用于识别您的应用*/
        appKey : "6h1edzo",

        buttonId: [
          { idName: 'appBtn2', params: data },
          { idName: 'appBtn3', params: data },
        ],

        /*—————————————————分割线——————————————————*/
        /*附加功能1：特殊情况无法直接跳转下载时，引导打开三方浏览器下载的遮罩层可用以下方法自定义样式*/
        //mask:function(){
        //  return "<div style='background:rgba(0,0,0,.5);position:fixed;left:0;top:0;filter:alpha(opacity=50);width:100%;height:100%;z-index:9999;'><div style='text-align:right; margin-top:1%; margin-right:5%;'><img style='width:70%; margin:0 auto;' src='https://cdn.xinstall.com/image/no_safari.png'/></div></div>"
        //},
        /*—————————————————分割线——————————————————*/
        /*xinstall初始化完成的回调函数*/
        // onready : function() {
        //   var m = this, button = document.getElementById("appBtn2");
        //   /*用户点击您页面上的某个按钮时(假定您的按钮id为downloadButton)，安装app*/
        //   /*
        //     警告：
        //     1、被绑定使用xinstall下载拉起的id，不需要额外再单独写下载相关的处理，如使用a标签href另外下载或者使用js绑定点击使用额外的下载，这样会导致拉起和数据传递失效！！！
        //     2、按钮id值请勿与附加功能2中重复使用，否则将导致功能失效！！
        //   */
        //   button.onclick = function() {
        //     m.wakeupOrInstall();
        //   }
        // }
      }, data);
    },false);
    document.head.appendChild(s);
  },

  // created() {
  //   var that = this
  //   var u = navigator.userAgent;
  //   var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  //
  //
  //   // if (isAndroid) {
  //   //   fetch({
  //   //     url: "https://app.yunduihua.net/ydh-app/common/version/android",
  //   //     method: "get"
  //   //   }).then((res) => {
  //   //     that.appUrl = res.data.downloadUrl
  //   //     that.androidUrl = res.data.downloadUrl
  //   //   })
  //   // } else {
  //   //   this.appUrl = 'https://apps.apple.com/us/app/云对话-智能教练平台/id1474569837?l=zh&ls=1'
  //   // }
  //
  //   // that.wxShare()
  // },

  // methods: {
  //   wxShare() {
  //     var shareUrl = window.location.href
  //     var url = window.location.href.split("#")[0];
  //     fetch({
  //       url: "https://app.yunduihua.net/ydh-app/third-party/wechat/share_mp",
  //       method: "post", data: {url: url}
  //     }).then((res) => {
  //       debugger
  //       let data = res;
  //       wx.config({
  //         debug: false,
  //         appId: data.appId,
  //         timestamp: data.timestamp,
  //         nonceStr: data.nonceStr,
  //         signature: data.signature,
  //         jsApiList: [
  //           "onMenuShareTimeline",
  //           "onMenuShareAppMessage",
  //           "updateAppMessageShareData",
  //           "updateTimelineShareData",
  //         ],
  //       });
  //
  //       wx.ready(() => {
  //         var shareData = {
  //           title: "云对话APP下载链接",
  //           desc: "云对话APP下载链接",
  //           link: shareUrl,
  //           imgUrl: "https://app.yunduihua.net/wxtapp-share/logo.png",
  //           success: () => {
  //           },
  //         };
  //         wx.updateAppMessageShareData(shareData);
  //         wx.updateTimelineShareData(shareData);
  //         wx.onMenuShareTimeline(shareData);
  //         wx.onMenuShareAppMessage(shareData);
  //       });
  //     });
  //
  //   }
  // }
}





</script>

<style lang='less' scoped>
.container {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #000000;
  background-color: #f6f6f6;
}

.bg-container {
  height: 100vh;
}

.top-btn-box {
  width: calc(100% - 48px);

  padding:12px 24px;
  font-weight: 600;
  align-items: center;
  display: inline-flex;
  font-size: 16px;
  color: #0D0D0D;
}

.top-logo-box {
  flex:1;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: #0D0D0D;
  font-weight: normal;
}

.top-btn-box img {
  width: 32px;
  height: 32px;
  margin-right: 13px;
}

.container-info {
  background-color: #FFE10F;
  border-radius: 20px 20px 0px 0px;
  width: calc(100% - 24px);
  padding-top: 12px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 24px;
  flex:1;
}

.info-content {
  background-color: #FFF;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 14px;
}

.info-desc {
  margin:28px 24px 0px 24px;
  font-size: 14px;
  color: #0D0D0D;
  font-weight: bold;
}

.center-img {
  margin:34px 10px 0px 10px;
  width: calc(100% - 20px);
}

.androi-tip {
  position: absolute;
  top: 100px;
}

.down-btn {
  background-image: url('../../assets/images/share/footer_bg.png');
  background-repeat: no-repeat;
  background-size: 227px 75px;
  color: #0D0D0D;
  height: 75px;
  width: 227px;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  display: inline-flex;
  justify-content: center;
}

.down-btn-box {
  padding-top: 25px;
  display: inline-flex;
}

.open-box {
  width: 103px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 26px;
  font-weight: 600;
  font-size: 16px;
  color: #0D0D0D;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.open-box img {
  width: 20px;
  height: 13px;
  margin-right: 8px;
}


.top-open-btn {
  height: 24px;
  background-color: #FFE10F;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  font-weight: 500;
  padding:0px 8px;
  border-radius: 12px;
  color: #0D0D0D;
}
</style>
